export const firebaseErrorMessages: Record<string, string> = {
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/user-not-found': 'We could not find an account with that email.',
  'auth/wrong-password': 'That password is incorrect. Please try again.',
  'auth/too-many-requests':
    'Too many sign-in attempts. Please wait a moment and try again.',
  'auth/email-already-in-use': 'This email is already linked to an account.',
  'auth/network-request-failed':
    'We could not reach the network. Please check your connection and try again.',
  'auth/invalid-credential':
    'The email or password is incorrect. Please check your details and try again.',
  'auth/weak-password':
    'Please choose a stronger password with at least 8 characters.',
};
